const roleCheck = (userRole, allowedRoles) => {
    // Normalize role by removing regional suffix for comparison
    // This allows User (EMEA) to match ROLES.User, External (EMEA) to match ROLES.External, etc.
    const normalizedUserRole = userRole?.replace(' (EMEA)', '');
    const normalizedAllowedRoles = allowedRoles.map(role => role?.replace(' (EMEA)', ''));
    
    return normalizedAllowedRoles.includes(normalizedUserRole);
};

export default roleCheck;
